//@ts-check

/**
 * @type {import('./types').string2xmlType}
 */
function string2xml(xmlString) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'text/xml';
  var parser = new DOMParser();
  var xmlDoc = parser.parseFromString(xmlString, format || 'text/xml');
  return xmlDoc;
}

export default string2xml;